<template>
  <div class="assurance rightMenu-box-wrapper bootstrap">
<!--    <div class="text-center user-count">-->
<!--      <h3>Уже <b>26</b> победителей по всей стране. Ты следующий!</h3>-->
<!--    </div>-->

    <div>
      <div v-if="showSuccessPage" style="padding: 100px 0; text-align: center;">
        <h2 style="color: white;">Данные успешно отправлены. <br/>Мы свяжемся с Вами для уточнения деталей<br/> в
          ближайшее время</h2>
<!--        <h4 style="color: white;">В связи с Новогодними праздниками, все призы, оформленные с 28.12.2024 г. по 09.01.2025 г., <br />будут отправлены Победителям 10.01.2025 г. Благодарим за понимание! С Новым годом!</h4>-->
      </div>
      <div v-if="showForm" style="padding: 100px 0;">
        <div >
          <div style="width: 80%; margin-left: 10%;">
            <h1 class="text-center text-orange" style="margin-bottom: 60px; ">ПОЗДРАВЛЯЕМ! ВЫБЕРИТЕ СВОЙ ПРИЗ</h1>
            <div class="pS_slider promoSliderScope slider2" ref="slider2">
              <div class="slider_item" :data-slick-index="product.id" :code="product.code" v-for="product in products2"
                   :key="product.id">
                <a target="_blank" :href="'/catalog/item/'+ product.id +'/'">
                <h5 >{{ product.name }}</h5>
                <img :src="'/images/promo-09/nabory/' + product.code  + '.png'" class="w100" alt="">
                <h5>{{ product.articul }}</h5>
                </a>
              </div>
            </div>
            <div id="userForm" class="text-center"><a href="#userForm" class="btn btn-orange text-white font-size-130" style="font-size: 1.5rem">Выбрать приз</a></div>
          </div>
        </div>
        <p >&nbsp;</p>


        <div class="row user-form" >
          <div class="col-md-1">&nbsp;</div>
          <div class="col-md-10">
            <h2 class="text-center text-orange">ЗАПОЛНИТЕ ФОРМУ ДЛЯ ВРУЧЕНИЯ ПРИЗА</h2>
            <div class="row">
              <div class="col-md-12" v-if="getCurrentProduct()">
                <label>Выбранный Вами приз:</label>
                <input type="text" class="form-control" style="font-size: 150%;" disabled :value="getCurrentProduct().name">
              </div>
            </div>
            <div class="row ">
              <div class="col-md-4">
                <label>ФИО (полностью) <sup>*</sup></label>
                <input type="text" class="form-control" v-model="userData.fio">
              </div>
              <div class="col-md-4">
                <label>Телефон <sup>*</sup></label>
                <input type="text" class="form-control" v-mask="'+7 (###) ###-##-##'" v-model="userData.phone"  >
              </div>
              <div class="col-md-4">
                <label>E-mail <sup>*</sup></label>
                <input type="text" class="form-control" v-model="userData.email">
              </div>
            </div>
            <div class="row ">
              <div class="col-md-6">
                <label>Адрес для отправки приза (с индексом) <sup>*</sup></label>
                <input type="text" class="form-control" v-model="userData.address">
              </div>
              <div class="col-md-6">
                <label>Где Вы приобрели набор? </label>
                <input type="text" class="form-control" v-model="userData.whereToBuy">
              </div>
            </div>

            <div class="row ">
              <div class="col-md-12">
                <div class="w100" style="padding-bottom: 20px;">
                  <img src="/images/promo-09/skidka_b.png" class="w100" alt="">
                </div>
                <label style="font-size: 150%;">Загрузите свое фото с набором (не
                  более {{ maxFileSize }} мегабайт) и получите промокод на скидку 30% в интернет магазине Pride.RU (действителен до 30 апреля 2025 года.)</label>
                <div v-if="isFileToBig()" class="text-danger">Размер файла больше {{ maxFileSize }} мегабайт</div>
                <input type="file" class="form-control" ref="file" @change="uploadFile">
                <img v-if="fileContent" :src="fileContent" alt="" style="max-width: 600px; max-height: 600px;" >
                <div v-if="fileContent" style="margin: 10px 0;"><a href="javascript:void(0)" @click="removeFile">удалить фото</a></div>
              </div>
            </div>

<!--            <div class="row mb-2" v-if="!showPassport">-->
<!--              <div class="col-md-12">-->
<!--                <a href="javascript:void(0)" @click="showPassport=true">заполнить паспортные данные</a>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="row " v-if="showPassport">-->
<!--              <div class="col-md-4">-->
<!--                <label>Паспорт (серия, номер) </label>-->
<!--                <input type="text" class="form-control" v-model="userData.passportNumber">-->
<!--              </div>-->
<!--              <div class="col-md-4">-->
<!--                <label>Кем и когда выдан </label>-->
<!--                <input type="text" class="form-control" v-model="userData.passportWhere">-->
<!--              </div>-->
<!--              <div class="col-md-4">-->
<!--                <label>Дата рождения </label>-->
<!--                <input type="date" class="form-control" v-model="userData.birthday">-->
<!--              </div>-->
<!--            </div>-->

            <div class="row">
              <div class="col-md-12 text-white" style="margin-bottom: 10px;">
                <input type="checkbox" v-model="agreeWithPrivacy"> &nbsp; даю согласие на обработку персональных данных и использование переданного/загруженного изображения, согласно ст.152.1 ГК РФ<br />
                <input type="checkbox" v-model="agree18"> &nbsp; мне больше 18 лет<br />
                <input type="checkbox" v-model="agreeRussia"> &nbsp; я гражданин Российской Федерации<br />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <button class="btn btn-orange" style="font-size: 150%; padding: 1.5rem 10rem; max-width: 100%;"
                        @click="sendForm()">Отправить
                </button>
                <div class="text-orange" style="margin-top : 15px;">* - поля обязательные для заполнения</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showInitialPage">
        <div class="row">
          <div class="col">
            <img src="/images/promo-09/ZL.jpg" class="w100" alt="">
          </div>
        </div>
        <div class="golden-line"></div>
        <div class="row">
          <div class="col">
            <img src="/images/promo-09/Promo_z1.png" class="w100" style="margin-top: 50px;" alt=""/>
            <div class="row">
              <div class="col-md-3">
                <a href="#nabory"><img src="/images/promo-09/Promo_s1.png" class="w100" alt=""></a>
              </div>
              <div class="col-md-3">
                <img src="/images/promo-09/Promo_s2.png" class="w100" alt="">
              </div>
              <div class="col-md-3" style="position:relative;">
                <div
                    style="position: absolute; bottom: 8%; width: 80%; left: 10%; background: url(/images/promo-09/Pin.jpg) no-repeat center center ; background-size: auto 100%;  ">
                  <div style="width: 70px; height: 70px; position: absolute; left: 62%; cursor: pointer;"
                       @click="check()"></div>
                  <input type="text" class="promocode" placeholder="****" v-model="promocode"/>
                </div>
                <img src="/images/promo-09/Promo_s3.png" class="w100" alt="">
              </div>
              <div class="col-md-3">
                <a href="#prize"><img src="/images/promo-09/Promo_s4.png" class="w100" alt=""></a>
              </div>
            </div>

            <div class="row justify-content-md-center" style="margin: 50px 0;">
              <div class="col-md-4 text-center">
                <div class="btn btn-orange btn-lg"
                     style="padding: 0.5rem 4rem; color: white; text-decoration: underline;">
                  <a href="/files/golden-rule.pdf" target="_blank" class="text-white">Правила участия</a>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div id="prize" class="golden-line"></div>

        <div>
          <div>
            <img src="/images/promo-09/Promo_z2.png" class="w100" alt="">
          </div>
          <div class="row">
            <div style="width: 80%; margin-left: 10%;">
              <div class="pS_slider promoSliderScope" ref="slider">
                <div class="slider_item" v-for="product in products2" :key="product.id">
                  <h5>{{ product.name }}</h5>
                  <a target="_blank" :href="'/catalog/item/'+ product.id +'/'"><img
                      :src="'/images/promo-09/nabory/' + product.code  + '.png'" class="w100" alt=""/></a>
                  <h5>{{ product.articul }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="nabory" class="golden-line"></div>

        <div>
          <img src="/images/promo-09/Promo_z3.png" class="w100" alt="">

          <div class="row">
            <div class="col-md-3" style="position: relative" v-for="product in products" :key="product.id">
              <a target="_blank" :href="'/catalog/item/'+ product.id +'/'">
                <div class="rtlabel text-center"><h3>{{ product.articul }}</h3></div>
                <img :src="'/images/promo-09/nabory/' + product.code  + '.png'" class="nabor-item" alt="">
                <div class="nabor-label">
                  <h6>{{ product.name }}</h6>
                </div>
                <img src="/images/promo-09/Promo_nabor_bg.png" class="w100" alt="">
              </a>
            </div>
          </div>

          <div class="row " style="margin-top: 50px;">
            <div class="col-md-7 text-right">
              <img src="/images/promo-09/Promo_nabor_img.png" class="w100" alt="">
            </div>
            <div class="col-md-5 ttr">
              <div class="row">
                <div class="col-1 d-none d-md-block">
                  <img src="/images/promo-09/Promo_LsG.png" class="w100" style="min-width: 25px;" alt="">
                </div>
                <div class="col-11">
                  <h2 style="font-size: 2.3rem">проверяйте наличие пломбы</h2>
                </div>
              </div>
              <div class="row">
                <div class="col-1"></div>
                <div class="col-11"><h3>и обязательно</h3></div>

              </div>
              <div class="row">
                <div class="col-1 d-none d-md-block">
                  <img src="/images/promo-09/Promo_LsG.png" class="w100" style="min-width: 25px;" alt="">
                </div>
                <div class="col-11">
                  <h2 style="font-size: 2.3rem">требуйте оригинальную упаковку</h2>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div>
          <img src="/images/promo-09/Promo_z4.png" class="w100" alt="">

          <div class="row">
            <div style="width: 90%; margin-left: 5%;">
              <div class="pS_slider promoSliderScope promoSliderScopeWinners" ref="slider_win">
                <div class="slider_item text-center text-white-50"  :key="winner.index" v-for="winner in winners" >
                  <img :src="'/images/promo-09/winners/' + winner.image" class="mw-100" alt="">
                  <div class="mt-2 mb-2 h5"  >{{winner.name}}</div>
                  <div class="h5" >{{winner.city_name}}</div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>

import {hashcheck} from "@/assets/libs/md5";

export default {
  name: 'PromoGoldenAction',
  props: ['products', 'products2'],
  data() {
    return {
      promocode: null,
      userData: {},
      showInitialPage: true,
      showForm: false,
      showSuccessPage: false,
      showPassport: false,
      maxFileSize: 2,
      fileContent: null,
      giftCode: null,
      agreeWithPrivacy: false,
      agree18: false,
      agreeRussia: false,
      winners: []
    }
  },
  methods: {
    sendForm() {
      this.userData.promocode = this.promocode
      this.userData.giftCode = this.giftCode
      this.userData.sign = hashcheck(this.promocode + 'bk21Jh4S5g')

      let error = [];
      if (!this.userData.fio) error.push('Не указано имя');
      if (!this.userData.email) error.push('Не указан email');
      if (!this.userData.phone) error.push('Не указан телефон');
      if (!this.userData.address) error.push('Не указан адрес');

      if (!this.agreeWithPrivacy) error.push('Необходимо указать что Вы согласны с правилами обработкии персональных данных')
      if (!this.agree18) error.push('Необходимо указать что Вам больше 18 лет')
      if (!this.agreeRussia) error.push('Необходимо указать что Вы гражданин Российской Федерации')

      this.showError(error);

      if (error.length) return
      //
      this.$http.post('/promo-golden/save-user-data/', this.userData).then(response => {
        console.log(response)
        this.showSuccessPage = true
        this.showForm = false
        this.showInitialPage = false
      })
    },
    getWinners() {
      return this.$http.get('/promo-golden/get-winners/').then(response => {
        this.winners = response.data
      })
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
      })
    },
    async uploadFile() {
      this.userData.fileContent = await this.toBase64(this.$refs.file.files[0])
      this.fileContent = await this.toBase64(this.$refs.file.files[0])
    },

    removeFile() {
      this.userData.fileContent = null
      this.fileContent = null
    },
    isFileToBig() {
      return this.userData.fileContent && this.userData.fileContent.length * 0.75 / 1024 > this.maxFileSize * 1024
    },
    showError(error) {
      if (error.length > 0) {
        this.$modal.show('dialog', {
          title: 'Ошибки заполнения',
          text: '<ul class="order-errors-list"><li>' + error.join('</li><li>') + '</li></ul>',
          buttons: [
            {
              title: 'Закрыть'
            }
          ]
        })
        return
      }
    },
    check() {
      if (!this.promocode) {
        this.showError(['Необходимо указать промокод'])
        return;
      }

      const relation = {
        'У': 'Y',
        'К': 'K',
        'Е': 'E',
        'Н': 'H',
        'Х': 'X',
        'В': 'B',
        'А': 'A',
        'Р': 'P',
        'О': 'O',
        'С': 'C',
        'М': 'M',
        'Т': 'T',
      };

      for (const [key, value] of Object.entries(relation)) {
        this.promocode = this.promocode.replace(key, value)
      }

      let that = this

      this.$http.post('/promo-golden/check-promocode/', {
        code: this.promocode,
        sign: hashcheck(this.promocode + 'bk21Jh4S5g')
      }).then(() => {
        this.showForm = true
        this.showInitialPage = false
        window.$("html, body").animate({ scrollTop: 0 }, "slow");

        setTimeout(() => {
          window.$('.slider2').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 1000,
            dots: false,
            infinite: true,
            arrows: true,
            swipe: true,
            rows: 0,
            prevArrow: '<div class="slick-prev"><img src="/images/promo-09/Promo_Ls.png" alt=""></div>',
            nextArrow: '<div class="slick-next"><img src="/images/promo-09/Promo_Rs.png" alt=""></div>',

            responsive: [
              {
                breakpoint: 951,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              },
              {
                breakpoint: 621,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          });

          if (window.$('.slick-active').length > 1) {
            that.giftCode = window.$('.slick-active').eq(1).attr('code');
          } else {
            that.giftCode = window.$('.slick-active').attr('code');
          }

          window.$('.slider2').on('afterChange', function () {
            if (window.$('.slick-active').length > 1) {
              that.giftCode = window.$('.slick-active').eq(1).attr('code');
            } else {
              that.giftCode = window.$('.slick-active').attr('code');
            }
          });


        }, 300)


      })

    },
    getCurrentProduct() {
      if(!this.giftCode){
        return null
      }
      return this.products2.find(product => product.code === this.giftCode)
    }
  },
  watch: {
    'userData.phone': function(newVal) {
      if (newVal && newVal[0] === '8') {
        this.userData.phone = '+7' + newVal.substring(1);
      }
    }
  },
  mounted() {
    window.$(this.$refs.slider).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      speed: 1000,
      dots: false,
      infinite: true,
      arrows: true,
      swipe: true,
      rows: 0,
      prevArrow: '<div class="slick-prev"><img src="/images/promo-09/Promo_Ls.png" alt=""></div>',
      nextArrow: '<div class="slick-next"><img src="/images/promo-09/Promo_Rs.png" alt=""></div>',
      responsive: [
        {
          breakpoint: 951,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 621,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    this.getWinners().then(() => {
      window.$(this.$refs.slider_win).slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        speed: 1000,
        dots: false,
        infinite: true,
        arrows: true,
        swipe: true,
        rows: 0,
        prevArrow: '<div class="slick-prev"><img src="/images/promo-09/Promo_Ls.png" alt=""></div>',
        nextArrow: '<div class="slick-next"><img src="/images/promo-09/Promo_Rs.png" alt=""></div>',
        responsive: [
          {
            breakpoint: 951,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 621,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    })
  }
}
</script>

<style lang="scss">


.promoSliderScope {
  background: url(/images/promo-09/BG2N.jpg) no-repeat center center;
  background-size: 95% 95%;

  .slider_item h5 {
    color: white !important;
    text-align: center;
    width: 80%;
    margin-left: 10%;
    min-height: 120px;
  }

  .slick-prev,
  .slick-next {
    font-size: 0;
    line-height: 0;

    position: absolute;
    top: 50%;

    display: block;

    width: 60px;
    height: 160px;
    padding: 0;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    transform: translate(0, -50%);

    cursor: pointer;

    color: transparent;
    border: none;
    outline: none;
    background: transparent;

    z-index: 10;
  }

  .slick-prev:hover,
  .slick-prev:focus,
  .slick-next:hover,
  .slick-next:focus {
    color: transparent;
    outline: none;
    background: transparent;
  }

  .slick-prev:hover:before,
  .slick-prev:focus:before,
  .slick-next:hover:before,
  .slick-next:focus:before {
    opacity: 1;
  }

  .slick-prev.slick-disabled:before,
  .slick-next.slick-disabled:before {
    opacity: .25;
  }

  .slick-prev:before,
  .slick-next:before {
    font-family: 'slick';
    font-size: 60px;
    line-height: 1;

    opacity: .75;
    color: white;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .slick-prev {
    left: -25px;
  }

  [dir='rtl'] .slick-prev {
    right: -25px;
    left: auto;
  }

  .slick-next {
    right: -25px;
  }

  [dir='rtl'] .slick-next {
    right: auto;
    left: -25px;
  }


}

.promoSliderScopeWinners {
  background: none;

  .slick-prev {
    left: -65px;
  }

  [dir='rtl'] .slick-prev {
    right: -75px;
    left: auto;
  }

  .slick-next {
    right: -75px;
  }

  [dir='rtl'] .slick-next {
    right: auto;
    left: -75px;
  }

  .slider_item {
    padding: 0 5px;
  }
}


</style>

<style lang="scss" scoped>

.user-count {

  h3 {
    padding: 15px;
    color: white;

    b {
      font-size: 130%;
      color: #ff570f;
    }
  }



}

.winner_slide {
  max-width: 25%;
}

.fancybox-button.fancybox-button--close {
  background: white;
}

.ttr h2, .ttr h3 {
  color: #ffff9f;

  & > div {
    margin-top: 20%;
    margin-bottom: 20%;
  }
}

.user-form {
  label, h2, h4 {
    color: white;
  }

  h2 {
    margin-bottom: 3rem !important;
  }

  input.form-control {
    padding: 0.5rem 2rem;
  }

  .col-md-6 {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }

  button {
    color: white !important;
  }

}

.row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}


.col-md-6 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.assurance {
  background: #0d0d0d;
}

.golden-line {
  width: 100%;
  background: url(/images/promo-09/golden-line.png);
  height: 5px;

}

.w100 {
  width: 100%;
}

input.promocode {
  width: 35%;
  font-size: 180%;
  margin: 20px;
  margin-left: 22%;
  border: 0px;
}

.bootstrap > div {
  max-width: 1920px;
  margin: 0 auto;
}

@media (min-width: 1900px) {
  input.promocode {
    width: 25%;
    font-size: 180%;
    margin: 20px;
    margin-left: 32%;
    border: 0px;
  }

}

.rtlabel {
  background: white;
  border-radius: 2px;
  width: 80%;
  margin-left: 10%;
  margin-bottom: 20px;

  h3 {
    font-size: 1.6rem;
  }
}

.nabor-item {
  position: absolute;
  width: 56%;
  bottom: 35%;
  left: 22%;
}

.nabor-label {
  position: absolute;
  width: 80%;
  bottom: 5%;
  left: 10%;
  text-align: center;
  height: 130px;
  display: table;

  h6 {
    color: white;
    vertical-align: baseline;
    display:table-cell;
    vertical-align:middle
  }
}



</style>
